// One "added to cart" signal for EVERY place a shopper can add something (store page, Design Studio cards, the
// Design Studio product block, the product page, the marketplace). It feeds the seller's "Left in carts" panel.
// It used to be called from the classic store page only, so a store that switched to Design Studio (MCXi on ~3 Oct,
// Nuneearts, …) silently stopped showing carts. Fire-and-forget; never throws; never fires for the demo store.
import { api } from "../config/api.js";
import { cartEventFor } from "./cartEvent.js";

export function trackAdd(product, opts) {
  try { const evt = cartEventFor(product, opts); if (evt) api.trackCart(evt); } catch { /* never block a purchase */ }
}
